import produce from "immer";

import {
  EDIT_STATE_WAYBILL,
  SEARCH_DISTRIBUTE_ORDER_FAILURE,
  SEARCH_DISTRIBUTE_ORDER_REQUEST,
  SEARCH_DISTRIBUTE_ORDER_SUCCESS
} from "src/actions/distributeOrderActions";

const initialState = {
  distributeOrders: [],
  total: 0,
  loading: false
};

const distributeOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_DISTRIBUTE_ORDER_REQUEST: {
      return produce(state, (draft) => {
        draft.distributeOrders = [];
        draft.loading = true;
      });
    }

    case SEARCH_DISTRIBUTE_ORDER_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.distributeOrders = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case SEARCH_DISTRIBUTE_ORDER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case EDIT_STATE_WAYBILL: {
      const {id, data} = action.payload;
      return produce(state, (draft) => {
        draft.distributeOrders = state.distributeOrders.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              status: data
            };
          }
          return item;
        });
      });
    }

    default: {
      return state;
    }
  }
};

export default distributeOrderReducer;
